import { render, staticRenderFns } from "./DeletePositionDialog.vue?vue&type=template&id=8548ef84&scoped=true"
import script from "./DeletePositionDialog.vue?vue&type=script&lang=js"
export * from "./DeletePositionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8548ef84",
  null
  
)

export default component.exports